import React from "react";

import { Label } from "@/components/ui/label";
import { RemotePicker, type PickerRow } from "@/components/pickers/RemotePicker";

/**
 * Поле-пикер с подписью.
 *
 * `blockedHint` задан → родитель ещё не выбран, поле неактивно и подпись
 * объясняет почему. Без этого зависимый пикер молча отдавал бы пустой список,
 * и это читалось бы как «в 1С ничего нет».
 */
export function PickerField({
  label,
  hint,
  blockedHint,
  value,
  onChange,
  search,
  queryKey,
  placeholder,
}: {
  label: string;
  hint?: string;
  blockedHint?: string;
  value: PickerRow | null;
  onChange: (row: PickerRow | null) => void;
  search: (q: string) => Promise<PickerRow[]>;
  queryKey: ReadonlyArray<unknown>;
  placeholder: string;
}): React.ReactElement {
  const blocked = Boolean(blockedHint);
  const note = blocked ? blockedHint : hint;
  return (
    <div>
      <Label className="text-xs">{label}</Label>
      <RemotePicker
        value={value}
        onChange={onChange}
        search={search}
        queryKey={queryKey}
        placeholder={blocked ? (blockedHint as string) : placeholder}
        disabled={blocked}
      />
      {note && <p className="mt-0.5 text-xs text-muted-foreground">{note}</p>}
    </div>
  );
}
